import React, { createContext, useContext, useState } from "react";
import firebase from "firebase/app";
import "firebase/analytics";
import "firebase/firestore";
import "firebase/auth";

const firebaseConfig = {
  apiKey: "AIzaSyDqH9clptgaxQjMMHrFxmFqi_-c4aS14dM",
  authDomain: "timeshot-56ffe.firebaseapp.com",
  // databaseURL: "timeshot-56ffe-default-rtdb.firebaseio.com",
  projectId: "timeshot-56ffe",
  storageBucket: "timeshot-56ffe.appspot.com",
  messagingSenderId: "529099368621",
  appId: "1:529099368621:web:45c82a2ffe36895c66fe24",
  measurementId: "G-V32MYJ1BT1"
};

firebase.initializeApp(firebaseConfig);

type TrackingProviderProps = {
  children: React.ReactNode;
};

type CollectionType = firebase.firestore.CollectionReference<
  firebase.firestore.DocumentData
>;

type createUserOnFirebaseType = (
  email: string,
  password: string
) => Promise<void>;
type doUserLoginOnFirebaseType = (
  email: string,
  password: string
) => Promise<void>;
type logoutUserFromFirebaseType = () => Promise<void>;

type FirebaseState = {
  user: firebase.User | null;
  isFetchingUser: boolean;
  db: any;
  auth: firebase.auth.Auth;
  analytics: firebase.analytics.Analytics;

  createUserOnFirebase: createUserOnFirebaseType;
  doUserLoginOnFirebase: doUserLoginOnFirebaseType;
  logoutUserFromFirebase: logoutUserFromFirebaseType;
};

const FirebaseContext = createContext<FirebaseState | undefined>(undefined);

function FirebaseProvider({ children }: TrackingProviderProps) {
  const firestore = firebase.firestore();
  const auth = firebase.auth();
  const analytics = firebase.analytics();

  // AUTHENTICATION
  const [user, setUser] = useState<firebase.User | null>(null);
  const [isFetchingUser, setIsFetchingUser] = useState(true);

  auth.onAuthStateChanged((user) => {
    if (user) {
      setUser(user);
    } else {
      setUser(null);
    }

    setIsFetchingUser(false);
  });

  const createUserOnFirebase: createUserOnFirebaseType = (email, password) =>
    new Promise(async (resolve, reject) => {
      try {
        var provider = new firebase.auth.GoogleAuthProvider();
        provider.addScope('https://www.googleapis.com/auth/calendar');

        const firebaseUser = await auth.signInWithPopup(provider);

        if (!firebaseUser.user) {
          reject();
          return;
        }

        await usersCollection.doc(firebaseUser.user.uid).set({
          email: firebaseUser.user.email,
        });

        resolve();
      } catch (e) {
        reject(e);
      }
    });

  const doUserLoginOnFirebase: doUserLoginOnFirebaseType = (email, password) =>
    new Promise(async (resolve, reject) => {
      try {
        await auth.signInWithEmailAndPassword(email, password);

        resolve();
      } catch (e) {
        reject(e);
      }
    });

  const logoutUserFromFirebase = async () => await auth.signOut();

  const db = firebase.firestore();

  // FIRESTORE
  const usersCollection = firestore.collection("users");

  return (
    <FirebaseContext.Provider
      value={{
        createUserOnFirebase,
        doUserLoginOnFirebase,
        logoutUserFromFirebase,
        user,
        isFetchingUser,
        db,
        auth,
        analytics
      }}
    >
      {children}
    </FirebaseContext.Provider>
  );
}

function useFirebase() {
  const context = useContext(FirebaseContext);

  if (context === undefined) {
    throw new Error("useFirebase must be used within a FirebaseProvider");
  }

  return context;
}

export { FirebaseProvider, useFirebase };
